<template>
  <b-container style="padding: 2rem 0rem;">
    <div class="ncuthead_01">
      <div id="topmenu" style="float: right;">
        <div id="middlemenu">
          <div class="logo" v-bind:style="{'position': titlePosition}">
            <img src="@/assets/images/logo0506.png" style="height: 80px; " alt="NCUT勤益校徵圖示" title="NCUT Logo" />
          </div>
        </div>
        <div class="ncuttitle"
          v-resize-text="{ratio:1.3, minFontSize: '30px', maxFontSize: '100px', delay: 200}">
            {{(null == setting || null == setting.sysTitle? '':setting.sysTitle[0].codeName)}}
        </div>
      </div>
      <div class="size_info">
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown text="字型大小" right>
            <b-dropdown-item href="#" @click="setSize(2)">大</b-dropdown-item>
            <b-dropdown-item href="#" @click="setSize(1)">一般</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </div>
    </div>
    <b-row class="justify-content-md-center">
      <b-col>
        <form class="form_login" method="post">
          <table cellspacing="0" style="width: 100%; border: 0; margin: 0 0 0.4em 0;">
            <tbody>
              <tr data-ng-show="viewModel.appMode==''">
                <td class="lab_td" style="width:11rem;">{{$t('message.ID_txt')}} <b-icon icon="person"></b-icon>：&nbsp;</td>
                <td class="inp_td" colspan="2">
                  <b-form-input placeholder="請輸入帳號" maxlength="20" tabindex="1" style="width:9.375em;"
                          v-model="user.id1"
                          :autofocus="true"></b-form-input>
                </td>
              </tr>
              <tr data-ng-show="viewModel.appMode==''">
                <td class="lab_td">{{$t('message.PassW_txt')}} <b-icon icon="key"></b-icon>：&nbsp;</td>
                <td class="inp_td" colspan="2">
                  <b-form-input type="password" placeholder="請輸入密碼" maxlength="20" tabindex="2" style="width:9.375em;"
                          v-model="user.id2"></b-form-input>
                </td>
              </tr>
              <tr data-ng-show="viewModel.appMode==''">
                <td class="lab_td">{{$t('message.ValiC_txt')}} <b-icon icon="pencil"></b-icon>：&nbsp;</td>
                <td class="inp_td" style="width: 6.5em;">
                  <b-form-input placeholder="請輸入驗證碼" maxlength="6" tabindex="3" style="width:6em;"
                          v-model="user.id3" @keyup.enter="login()"></b-form-input>
                </td>
                <td style="display:flex; padding: 0.3em;">
                  <img  v-if="captchaInfo != null" :src="captchaInfo" style="margin: 0 0 0 0; height: 2.25em;" alt="">
                  <a href="#" style="padding: 5px 0.6em;" title="重新產生驗證碼" tabindex="4"  @click.prevent="getCaptcha()">
                    <b-icon icon="bootstrap-reboot"></b-icon></a>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td style="padding: 1em 0 0;">
                  <b-button variant="primary" tabindex="5" @click.prevent="login()">
                    {{$t('message.Sign_in')}} <b-icon icon="door-open"/>
                  </b-button>
                </td>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ResizeText from 'vue-resize-text'
import * as tools from '../tool'
import { mapGetters } from 'vuex'
import vFooter from '@/components/common/FooterView'

export default {
  name: 'login',
  components: {
    vFooter
  },
  directives: {
      ResizeText
  },
  data () {
    return {
      user: {
        id1: '',
        id2: '',
        id3: '',
        isLogin: true,
        sysId: 0
      },
      queryInfo: {
        sysId: 11,
        schYY: '',
        smt  : 0,
        id   : 0,
        type : 3
      },
      captchaInfoArray: {
        text1: "",
        text2: "",
        text3: "",
      },
      optionId: 0,
      sysList: null,
      usrData: null,
      captchaInfo: null,
      appMode: 0,
      isIE: false
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    titlePosition () {
      return (this.isIE ? 'relative' : 'absolute')
    }
  },
  methods: {
    query() {
      var vm = this;
      this.queryInfo.sysId = this.sysId;
      this.queryInfo.schYY= this.sysInfo.schYY;
      this.queryInfo.smt  = this.sysInfo.smt;

      this.$http.put('./WebApi/Print/GetEduPrn', this.queryInfo)
          .then((response) => {
            if (!tools.isNull(response.data)) {
              vm.docRecordList = response.data
            }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error);
        })
    },
    setSize(val) {
      this.$store.dispatch('setSize', val)
    },
    getConfigureInfo: function (sysId) {
      return this.$http
        .get('./WebApi/Setting/GetConfigureList/'.concat(sysId))
    },
    clearUser () {
      this.user.id1 = ''
      this.user.id2 = ''
      this.user.id3 = ''
      this.user.isLogin = true
      this.appMode = 0
    },
    checkLoginData () {
      let msg = '';

      if (this.optionId == 0) {
        msg = '執行的系統';
      }

      return msg
    },
    confirm: function () {
      var vm = this
      var msg = this.checkLoginData()
      if (msg.length == 0) {
        this.$store.dispatch('setSysId', this.optionId)
        this.$http.all([vm.getConfigureInfo(this.optionId)])
          .then(vm.$http.spread(function (conInfo) {
            vm.$store.dispatch('setSetting', JSON.parse(conInfo.data))

            vm.$store.dispatch('actionLogin', vm.usrData)
            vm.clearUser()
            vm.$router.push({ path: 'main' })
          }))
      } else {
        tools.showAlert(vm, 'danger', '對不起,請輸入' + msg);
      }
    },
    cancel: function () {
      this.clearUser()
    },
    login: function () {
      var vm = this
      this.$http.put('./WebApi/Common/Authorized', this.user)
        .then((response) => {
          var tmpData = response.data
          if (!tools.isNull(tmpData) && (tmpData.usrData.id === vm.user.id1)) {
            //var sLen = tmpData.sysList.length
            vm.usrData = tmpData.usrData
            // vm.sysList = tmpData.sysList

            // if (!tools.isNull(tmpData.sysList) && (sLen > 0)) {
            //   if (sLen >=0) {
            //     if (vm.sysId != vm.sysList[0].id) {
            //       var tId = vm.sysList[0].id
            //       vm.$store.dispatch('setSysId', tId)
            //       vm.$http.all([vm.getConfigureInfo(tId)])
            //         .then(vm.$http.spread(function (conInfo) {
            //           vm.$store.dispatch('setSetting', JSON.parse(conInfo.data))

                      vm.$store.dispatch('actionLogin', vm.usrData)
                      vm.clearUser()
                      vm.$router.push({ path: 'main' })
              //       }))
              //   } else {
              //     vm.$store.dispatch('actionLogin', vm.usrData)
              //     vm.clearUser()
              //     vm.$router.push({ path: 'main' })
              //   }
              // } else {
              //   vm.appMode = 1
              // }
            // } else {
            // 	tools.showAlert(vm, 'danger', '請注意! 您沒有取得執行權限, 請聯絡承辦人員...');
            // 	vm.clearUser()
            // }
          } else {
            tools.showAlert(vm, 'danger', '請檢查帳號密碼是否輸入正確');
            vm.clearUser()
          }
        })
        .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起, 登入失敗, 請檢查帳號密碼是否輸入正確' + error);
        })
    },
    getCaptcha: function () {
      var vm = this
      this.$http
        .get('./WebApi/Common/GetCaptcha/')
        .then(function (response) {
          vm.captchaInfoArray = response.data;
           vm.captchaInfo = vm.captchaInfoArray.text2;
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error);
        })
    }
  },
  created () {
    console.log('======created Login =====')
    var userAgent = navigator.vendor
    if (userAgent.indexOf('Apple') > -1) {
      this.isIE = true
    } else {
      this.isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1 || navigator.userAgent.indexOf('Edge') > -1
    }
    // this.sysId =11 ;
    this.optionId = 11;
    this.user.sysId = 11;
    this.getCaptcha();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.input-205 {
  height: 2.05em;
  padding: 0.2em;
}

.ncuthead_01 {
  position: relative;
  height: 102px;
  background: transparent;
  background-position: 0px 0px;
  display: contents;
}
.ncuttitle {
  top: 1.5rem;
  left: 15rem;
  padding-bottom: 0px;
  position: absolute;
  font-weight: bolder;
  color: #161823;
  font-family: -apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;
}
.loginMenu {
  border-left: none;
  padding-left: 0;
  margin: 0;
  padding-right: .75em;
  line-height: 0.6;
  display: inline-block;
  list-style-type: none;
  list-style-position: inside;
  padding: .5em 0;
}
.itemMenu {
  border-left: 1px solid rgba(0,0,0,0.1);
  padding-left: .75em;
  padding-right: .75em;
  line-height: 0.6;
}
.form_login {
  max-width: 22.875em;
  min-height: 13.5em;
  margin: 7.375em auto;
  text-align: center;
  padding-top: 1em;
  border: 1px solid gray;
  vertical-align: top;
  border-radius: 4px;
  font-size: larger;
  background: linear-gradient(135deg,rgba(255,255,255,1) 0%,rgba(246,246,246,1) 60%,rgba(237,237,237,1) 100%);
}
.lab_td {
  line-height: 2.75;
  text-align: right;
}

.size_info {
    background-color: rgba(33,99,33, 0.2);
    position: absolute;
    top: 0.5rem;
    right: 1rem;
    color: #ffffa7;
}
.T3-content
{
  font-size: 0.5rem;
  padding: 0.3125em;
  border: 1px solid #c07800;
}
</style>
